import { Component, Input, OnInit } from "@angular/core";
import { runInThisContext } from "vm";
import { StaticPagesService } from "../Services/static-pages.service";

@Component({
    selector: "app-source-icons",
    templateUrl: "./source-icons.component.html",
    styleUrls: ["./source-icons.component.scss"],
})
export class SourceIconsComponent implements OnInit {
    @Input() source_type: any;
     environmentVariables:any;
      changeIconFill:boolean = true;
    constructor( private confgServ: StaticPagesService,) {
      this.getInitilizingData() 
    }

    
    ngOnInit(): void {}

        getInitilizingData() {
        this.confgServ.getenvConfig().subscribe((res) => {
            this.environmentVariables = res;
        });
  }


} 
